export default __webpack_public_path__ + "static/media/36.54ad6da2.png";